import { defineNuxtPlugin } from '#app/nuxt'
import { LazyIconLawyerAndFirmBriefcase, LazyIconLawyerAndFirmBuilding, LazyIconLawyerAndFirmGlobe, LazyIconLawyerAndFirmLocation, LazyIconArrowDownCircle, LazyIconArrowFullLeft, LazyIconArrowFullRight, LazyIconArrowLeft, LazyIconArrowRightCircle, LazyIconArrowRight, LazyIconArrowUpCircle, LazyIconArrowUp, LazyIconBell, LazyIconBlankUser, LazyIconBlock, LazyIconBlockedIcon, LazyIconBlueCheckmark, LazyIconBusiness, LazyIconCalendar, LazyIconCamera, LazyIconChecked, LazyIconClock, LazyIconCloseButton, LazyIconDanger, LazyIconDecline, LazyIconDoubleChecked, LazyIconEmail, LazyIconEyeHidden, LazyIconEyeShow, LazyIconFilesAdoc, LazyIconFilesDefault, LazyIconFilesDoc, LazyIconFilesDocx, LazyIconFilesExcel, LazyIconFilesPdf, LazyIconFilesTxt, LazyIconFilesZip, LazyIconGtLogo, LazyIconInfo, LazyIconLogin, LazyIconMinus, LazyIconOldschoolArrow, LazyIconPhone, LazyIconPlus, LazyIconPlusIcon, LazyIconPositionInOffice, LazyIconRatingStarHalf, LazyIconRatingStar, LazyIconReplay, LazyIconSearch, LazyIconSocialsFacebook, LazyIconSocialsGoogle, LazyIconSocialsLinkedin, LazyIconSocialsMessenger, LazyIconStarFillIcon, LazyIconStarIcon, LazyIconSuccess, LazyIconSwap, LazyIconTermsNConds, LazyIconUpload, LazyIconWebsite } from '#components'
const lazyGlobalComponents = [
  ["IconLawyerAndFirmBriefcase", LazyIconLawyerAndFirmBriefcase],
["IconLawyerAndFirmBuilding", LazyIconLawyerAndFirmBuilding],
["IconLawyerAndFirmGlobe", LazyIconLawyerAndFirmGlobe],
["IconLawyerAndFirmLocation", LazyIconLawyerAndFirmLocation],
["IconArrowDownCircle", LazyIconArrowDownCircle],
["IconArrowFullLeft", LazyIconArrowFullLeft],
["IconArrowFullRight", LazyIconArrowFullRight],
["IconArrowLeft", LazyIconArrowLeft],
["IconArrowRightCircle", LazyIconArrowRightCircle],
["IconArrowRight", LazyIconArrowRight],
["IconArrowUpCircle", LazyIconArrowUpCircle],
["IconArrowUp", LazyIconArrowUp],
["IconBell", LazyIconBell],
["IconBlankUser", LazyIconBlankUser],
["IconBlock", LazyIconBlock],
["IconBlockedIcon", LazyIconBlockedIcon],
["IconBlueCheckmark", LazyIconBlueCheckmark],
["IconBusiness", LazyIconBusiness],
["IconCalendar", LazyIconCalendar],
["IconCamera", LazyIconCamera],
["IconChecked", LazyIconChecked],
["IconClock", LazyIconClock],
["IconCloseButton", LazyIconCloseButton],
["IconDanger", LazyIconDanger],
["IconDecline", LazyIconDecline],
["IconDoubleChecked", LazyIconDoubleChecked],
["IconEmail", LazyIconEmail],
["IconEyeHidden", LazyIconEyeHidden],
["IconEyeShow", LazyIconEyeShow],
["IconFilesAdoc", LazyIconFilesAdoc],
["IconFilesDefault", LazyIconFilesDefault],
["IconFilesDoc", LazyIconFilesDoc],
["IconFilesDocx", LazyIconFilesDocx],
["IconFilesExcel", LazyIconFilesExcel],
["IconFilesPdf", LazyIconFilesPdf],
["IconFilesTxt", LazyIconFilesTxt],
["IconFilesZip", LazyIconFilesZip],
["IconGtLogo", LazyIconGtLogo],
["IconInfo", LazyIconInfo],
["IconLogin", LazyIconLogin],
["IconMinus", LazyIconMinus],
["IconOldschoolArrow", LazyIconOldschoolArrow],
["IconPhone", LazyIconPhone],
["IconPlus", LazyIconPlus],
["IconPlusIcon", LazyIconPlusIcon],
["IconPositionInOffice", LazyIconPositionInOffice],
["IconRatingStarHalf", LazyIconRatingStarHalf],
["IconRatingStar", LazyIconRatingStar],
["IconReplay", LazyIconReplay],
["IconSearch", LazyIconSearch],
["IconSocialsFacebook", LazyIconSocialsFacebook],
["IconSocialsGoogle", LazyIconSocialsGoogle],
["IconSocialsLinkedin", LazyIconSocialsLinkedin],
["IconSocialsMessenger", LazyIconSocialsMessenger],
["IconStarFillIcon", LazyIconStarFillIcon],
["IconStarIcon", LazyIconStarIcon],
["IconSuccess", LazyIconSuccess],
["IconSwap", LazyIconSwap],
["IconTermsNConds", LazyIconTermsNConds],
["IconUpload", LazyIconUpload],
["IconWebsite", LazyIconWebsite],
  
]

export default defineNuxtPlugin({
  name: 'nuxt:global-components',
  setup (nuxtApp) {
    for (const [name, component] of lazyGlobalComponents) {
      nuxtApp.vueApp.component(name, component)
      nuxtApp.vueApp.component('Lazy' + name, component)
    }
  }
})
